<!-- =========================================================================================
    Description: Developing Tools
========================================================================================== -->

<template>
  <div class="development-screen">
    <div class="development-panel-top flex flex-inline">
      <div class="flex flex-inline">
        <li
          v-for="(componentName, index) in componentList"
          :key="componentName">
          <button @click="switchComponent(index)">
            {{ componentName }}
          </button>
        </li>
        <select v-model="localData.context.currentStage">
          <option v-for="stage in contexts.stages" :key="stage[0]" :name="stage[0]">{{ stage[0] }}</option>
        </select>
      </div>
    </div>

    <div class="content-screen-wrapper">
      <layouts>
        <router-view v-if="localData.context.displayMode === 'router'" />
        <main-display v-if="localData.context.displayMode === 'component'" />
        <div v-else>
          Development Home
        </div>
      </layouts>
    </div>

    <div class="development-panel-bottom flex flex-inline">
      <div class="flex flex-inline">
        <div>
          View all Flatmap <button @click="getFlatmap">Get Flatmap</button>
          {{ flatmap }}
        </div>
        <div>
          Local Data
          {{ localData }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./init.js";
import { state, contexts, componentList } from "@/developing/dev-data.js";
import { loadComponents } from "@/developing/utils/modular";
// import DevEB from "./event-bus";

const components = loadComponents(componentList, contexts.stages);

export default {
  components: {
    ...components,
    layouts: () => import(`@/developing/layouts.vue`),
    "main-display": () => import(`@/developing/main.vue`)
  },
  async mounted() {
    // console.log("Developing", this);
  },
  data() {
    return {
      contexts,
      components,
      componentList,
      flatmap: [],
      localData: state
    }
  },
  watch: {
    "currentStage" (stage) {
      if (stage === "development") {
        this.dev = true;
        return;
      }
      this.dev = false;
    }
  },
  methods: {
    switchComponent(index) {
      this.localData.context.currentComponent = index;
    },
    getFlatmap() {
      this.flatmap = Array.from(this.$flatmap.entries()).reduce((main, [key, value]) => ({...main, [key]: value}), {});
    },
  }
}

</script>

<style lang="scss">
.development-screen {
  position: relative;
  width: 100%;
  height: 100%;
  background: whitesmoke;

  & .content-screen-wrapper {
    position: relative;
    width: 100%;
    height: calc(100% - 200px);
    overflow: hidden;
    background: white;
    padding: 2rem;

    & .vs-sidebar {
      position: absolute;
    }

    & .navbar {
      position: unset !important;

      & .vx-navbar-wrapper {
        position: absolute;
      }
    }

  }
  & .development-panel-top {
    height: 30px;
  }

  & .development-panel-bottom {
    height: 24px;
    position: fixed;
    bottom: 0;
    z-index: 999999;
    width: 100%;
  }
}


</style>
